import { Card, Col, Image, Row } from 'react-bootstrap';
import { CustomText } from 'components/CustomText';
import CustomButton from 'components/CustomButton';
import addSign from 'assets/pngs/add.png';
import { saveToUserStore } from 'redux/features/user/userSlice';
import { formatCurrency } from 'helper/formatText';

// Changing the voucher changes the total, so like the CHANGE buttons in the
// other sections it unfreezes the totals kept from an earlier payment attempt.
const VoucherSection = ({
  voucherDetails,
  voucherBalance,
  setFreeze,
  setVoucherDet,
  dispatch,
  setVoucherVisible,
  currencySymbol,
}) => {
  return (
    <>
      <Col lg={12}>
        <Card className="border-0 mt-2 mb-4 mb-lg-0 mb-md-0">
          <Card.Header>
            <Row>
              <Col>
                <CustomText
                  fontFamily={'Poppins'}
                  fontSize={14}
                  fontWeight={500}
                  text={'USE VOUCHER (Optional)'}
                />
              </Col>
              {!!voucherDetails && (
                <Col className="ms-auto d-flex justify-content-end">
                  <CustomButton
                    buttonTextColor={'text-primary'}
                    text="REMOVE"
                    variant="primary"
                    fontWeight={500}
                    fontSize={14}
                    style={{
                      padding: 0,
                      height: 20,
                      backgroundColor: 'transparent',
                      border: 'none',
                    }}
                    className="d-flex justify-content-end"
                    onPress={() => {
                      setFreeze(false);
                      setVoucherDet(null);
                      dispatch(
                        saveToUserStore({
                          key: 'currentVoucher',
                          value: null,
                        })
                      );
                    }}
                  />
                </Col>
              )}
            </Row>
          </Card.Header>
          <Card.Body className="py-3">
            {!voucherDetails && (
              <CustomText
                fontFamily={'Poppins'}
                fontSize={14}
                fontWeight={400}
                cNColor="text-primary"
                divClassName="align-items-center"
                onPress={() => {
                  setFreeze(false);
                  setVoucherVisible(true);
                }}
              >
                <Image src={addSign} style={{ marginRight: 16 }} />
                Pick a voucher
              </CustomText>
            )}
            {!!voucherDetails && (
              <div className="d-flex align-items-center">
                {voucherDetails?.svg}
                <div className="ms-3 d-flex flex-column align-items-start">
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    text={voucherDetails?.name}
                    divClassName="ps-3"
                  />
                  <CustomText
                    fontFamily={'Poppins'}
                    fontSize={14}
                    divClassName="ps-3"
                    cNColor="text-secondary"
                  >
                    Available Balance -{' '}
                    {formatCurrency(voucherBalance, 2, currencySymbol)}
                  </CustomText>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default VoucherSection;
